const STORAGE_KEY = 'graspil_default_dashboard_id';

// Returns the dashboard id explicitly chosen by the user as default, or null when
// the user hasn't chosen one (in which case the system dashboard matching the
// current resource type is used). 'standard' (old fixed dashboard) is a legacy
// value that may still be present in some browsers but can no longer be set —
// callers should treat it the same as null.
export function getDefaultDashboardId() {
    return localStorage.getItem(STORAGE_KEY) || null;
}

export function setDefaultDashboardId(id) {
    if (id) {
        localStorage.setItem(STORAGE_KEY, id);
    } else {
        localStorage.removeItem(STORAGE_KEY);
    }
}
